import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ReactComponent as Logo } from '../../assets/ecgo_logo.svg';
import bgImage from '../../assets/bg.png';
import { alpha } from '@mui/material';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <Box
        sx={(theme) => ({
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          width: '100%',
          flexDirection: 'column',
          background: theme.palette.common.white,
          height: '100vh',
        })}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
          <Logo style={{ width: 80, height: 80, marginBottom: 0 }} />
        </Box>
        {children}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '50%',
          backgroundColor: 'black',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <img
          src={bgImage}
          alt="Background"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        <Box
          sx={(theme) => ({
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: `linear-gradient(to top,${theme.palette.common.black} 0%, ${alpha(
              theme.palette.common.black,
              0.8,
            )} 30%, transparent 100%)`,
          })}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 0 }}>
            <Logo style={{ width: 120, height: 120, marginBottom: 48 }} />
          </Box>
          <Typography
            variant="h4"
            sx={(theme) => ({
              color: theme.palette.common.white,
              fontWeight: 600,
            })}
          >
            Snap, Recycle,
            <br /> Earn Rewards...
          </Typography>
        </Box>
      </Box>
      <Box
        sx={(theme) => ({
          width: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: theme.palette.common.white,
        })}
      >
        {children}
      </Box>
    </Box>
  );
}
